import { EdgeChangeProPlanRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ChangeProPlan } from '@/modules/auth/use-cases'

export function makeChangeProPlan(): ChangeProPlan {
  return new EdgeChangeProPlanRepository(makeSupabaseEdgeHttpClient()).execute
}
